import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { UserContext } from '../contexts/UserContext';

const PrivateRoute = () => {
  const userCtx = useContext(UserContext);
  const { setUserId } = userCtx;
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
        setLoading(false);
        setUserId(user.uid);
      } else {
        setLoading(false);
      }
    });
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        Loading...
      </div>
    );
  }

  return (
    <>
      {user ? (
        <Outlet />
      ) : (
        <div className="flex justify-center items-center h-screen">
          <Navigate to="/login" replace />
        </div>
      )}
    </>
  );
};

export default PrivateRoute;
